import React, { useEffect } from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const WeddingCar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Wedding Car - Coming Soon | Advait Tour and Travels"
        description="Wedding car rental service coming soon. Stay tuned for luxury wedding car options."
        keywords="wedding car, wedding car rental, luxury wedding cars"
        canonicalUrl={`${window.location?.origin}/wedding-car`}
        ogTitle="Wedding Car - Coming Soon | Advait Tour and Travels"
        ogDescription="Wedding car rental service coming soon. Stay tuned for luxury wedding car options."
        ogUrl={`${window.location?.origin}/wedding-car`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Wedding Car Rental",
          "description": "Wedding car rental service coming soon"
        }}
      />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-32 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
                Wedding Car
              </h1>
              <p className="text-3xl md:text-4xl text-yellow-400 text-center font-semibold">
                Coming Soon.......
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default WeddingCar;